import footerBackground from "../../assets/footer_background.svg";
import vat from "../../assets/VAT_SAUDI.webp";
import sbc from "../../assets/SBC_logo.png";
import qr from "../../assets/qr.png";
import followUs from "../../assets/follow_us.svg";
import instagram from "../../assets/ig_icon.svg";
import tiktok from "../../assets/blog-tiktok.svg";
import x from "../../assets/x_icon.svg";
import { socialLinks } from "../../utils/socialLink";
import footerLogos from "../../assets/footer_logo.svg";

export const Footer = () => {
  return (
    <footer
      style={{ backgroundImage: `url(${footerBackground})` }}
      className="relative z-10 flex flex-row items-center justify-between p-4 -mt-10 bg-center bg-no-repeat bg-cover md:py-4 md:px-8"
      dir="ltr"
    >
      <div className="space-y-3 md:pl-8 md:-mt-16">
        <img src={followUs} alt="follow us" className="h-10 md:h-20" />
        <div className="flex gap-4">
          <a
            className="footer-social-link"
            href={socialLinks.twitter}
            target="_blank"
            rel="noopener noreferrer"
          >
            <img src={x} alt="x" className="h-6 md:h-12" />
          </a>

          <a
            className="footer-social-link"
            href={socialLinks.instagram}
            target="_blank"
            rel="noopener noreferrer"
          >
            <img src={instagram} alt="instagram" className="h-6 md:h-12" />
          </a>

          <a
            className="footer-social-link"
            href={socialLinks.tiktok}
            target="_blank"
            rel="noopener noreferrer"
          >
            <img src={tiktok} alt="tiktok" className="h-6 md:h-12" />
          </a>
        </div>
      </div>

      <div className="md:hidden">
        <img src={footerLogos} alt="" />
      </div>

      <div className="hidden md:block">
        <div className="flex w-full h-10 px-8 mt-8 md:justify-start md:h-16">
          <img className="h-10 md:h-16" alt="vat" src={vat} />
          <img className="h-10 md:h-16" alt="sbc logo" src={sbc} />
          <img className="h-10 md:h-16" alt="qr sbc" src={qr} />
        </div>
        <div className="flex w-full h-16 gap-8 px-8 pt-2 md:justify-start">
          <div className="text-xs font-Inter text-landing-yellow ">
            الرقم الضريبي:311451087100003
          </div>
          <div className="text-xs font-Inter text-landing-yellow ">
            رقم التوثيق: 0000019557
          </div>
        </div>
      </div>
    </footer>
  );
};
